<ng-container>
  <div class="row saved-app" *ngIf="wizType === 'wiz-consumer-auto'">
    <div class="col-12">
      <button mat-raised-button color="primary" type="button" (click)="updateSelectedAppType('continue')" [disabled]="displaySavedApplications">Continue a saved application</button>
    </div>
  </div>
  <mat-card appearance="outlined" [formGroup]="formGroup" *ngIf="wizType === 'wiz-home-loan'">
    <mat-card-header>
      <mat-card-title>Application type</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="row">
        <div class="col-sm-12">
          <mat-label id="example-radio-group-label">Please choose how to proceed:</mat-label>
          <mat-radio-group formControlName="applicationType" (change)="updateSelectedAppType($event.value)">
            <ng-container *ngFor="let type of applicationTypes">
              <mat-radio-button *ngIf="(isInternalUser && type?.ext?.active?.internal) || (!isInternalUser && type?.ext?.active['third-party'])" [value]="type.id" style="display: flex; flex-direction: column">{{type.text}}</mat-radio-button>
            </ng-container>
          </mat-radio-group>
        </div>
      </div>

      <div class="row" *ngIf="formGroup.get('applicationType').value === 'old-personal'">
        <div class="col-11 offset-1">
          <mat-radio-group formControlName="furtherAdvanceApplicationType" (change)="updateFurtherAdvanceType($event.value)">
            <mat-radio-button *ngFor="let type of furtherAdvanceTypes" [value]="type.id" style="display: flex; flex-direction: column">{{type.text}}</mat-radio-button>
          </mat-radio-group>
          <mat-error>
            <app-validation-partial
              [formGroup]="formGroup"
              [fieldName]="'furtherAdvanceApplicationType'"
            ></app-validation-partial>
          </mat-error>
        </div>
      </div>

      <div class="row d-flex align-items-center mt-4" *ngIf="isFurtherAdvance || (formGroup?.value?.applicationType === 'old-personal' && !displaySavedApplications)">
        <div class="col-sm-4">
          <mat-form-field appearance="outline">
            <mat-label>Enter the existing application ID</mat-label>
            <input matInput placeholder="Enter the existing application ID" formControlName="appId">
            <mat-error>
              <app-validation-partial
                [formGroup]="formGroup"
                [fieldName]="'appId'"
              ></app-validation-partial>
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-sm-4">
          <button class="fmc-button-primary" mat-raised-button color="'primary'" type="button" [disabled]="importingFromJustice || loadingResults || !formGroup?.value?.appId" style="margin-right: 10px;"
            (click)="importApplication('old-personal')">
            <ng-container *ngIf="!importingFromJustice">Load</ng-container>
            <mat-spinner class="me-2" diameter="30" strokeWidth="3" mode="indeterminate" *ngIf="importingFromJustice"></mat-spinner>
          </button>
          <span *ngIf="showOpErrorMsg" style="color: #f44336; font-size: 10px; font-weight: 400;">Application not loaded</span>
        </div>
      </div>

      <div class="row" *ngIf="!isFurtherAdvance">
        <div class="col-12">
          <hr>
          <button mat-button color="primary" class="fmc-button-primary" type="button" (click)="updateSelectedAppType('continue')" [disabled]="displaySavedApplications">Continue a saved application</button>
        </div>
      </div>
    </mat-card-content>
  </mat-card>

  <mat-card appearance="outlined" *ngIf="displaySavedApplications && !isFurtherAdvance">
    <mat-card-header>
      <mat-card-title>Saved applications</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="row">
        <div class="col-sm-12">
          <mat-progress-bar mode="indeterminate" *ngIf="partialAppListLoading"></mat-progress-bar>
        </div>
      </div>
      <div class="row" *ngIf="!partialAppListLoading && partialApplications && partialApplications.length === 0">
        <div class="col-sm-12">
          <mat-error class="mt-5">
            There are no saved applications to proceed.
          </mat-error>
        </div>
      </div>
      <div class="row mt-4" *ngIf="partialApplications && partialApplications.length > 0">
        <div class="col-sm-12">
          <mat-accordion>
            <mat-expansion-panel *ngFor="let app of partialApplications; index as i" [hideToggle]="true">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <strong>{{ app.borrowers }}</strong>, Created {{ app.created | date: 'longDate' }}
                </mat-panel-title>
                <mat-panel-description style="flex: 0 0 auto;">
                  <button mat-raised-button color="'primary'" class="fmc-button-primary" type="button" (click)="loadPartial(app.id, app)">Select</button>
                  <button mat-raised-button color="'warn'" type="button" (click)="deletePartial(app.id, i)">Delete</button>
                </mat-panel-description>
              </mat-expansion-panel-header>
            </mat-expansion-panel>
          </mat-accordion>
          <mat-error class="mt-5">
            Please select an application to proceed.
          </mat-error>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</ng-container>
